import {
  component_styles_default
} from "./chunk.YTLQMGH4.js";
import {
  r
} from "./chunk.X63DNLWS.js";

// packages/web-components/src/components/Header/Header.styles.ts
var Header_styles_default = r`
  ${component_styles_default}

  .myd-header {
    color: var(--myd-text-block-color-text);
    font-family: var(--myd-text-block-typography-x-small-regular-font-family);
    font-weight: var(--myd-text-block-typography-x-small-regular-font-weight);
    line-height: var(--myd-text-block-typography-x-small-regular-line-height);
    font-size: var(--myd-text-block-typography-x-small-regular-font-size);
    letter-spacing: var(--myd-text-block-typography-x-small-regular-letter-spacing);
    paragraph-spacing: var(--myd-text-block-typography-x-small-regular-paragraph-spacing);
    paragraph-indent: var(--myd-text-block-typography-x-small-regular-paragraph-indent);
    text-case: var(--myd-text-block-typography-x-small-regular-text-case);
    text-decoration: var(--myd-text-block-typography-x-small-regular-text-decoration);
    display: flex;
    padding: var(--myd-header-spacing-mobile-top) var(--myd-header-spacing-mobile-left);
    justify-content: space-between;
    align-items: center;
  }

  .header__border {
    border: solid;
    border-image-source: var(--myd-header-color-border-gradient);
    border-image-slice: 1;
    border-width: 0 0 6px 0;
  }

  .header__leading-element {
    align-items: left;
    display: flex;
  }

  .header__trailing-element {
    align-items: right;
    display: flex;
    padding-left: var(--myd-header-spacing-mobile-x-left-right);
  }

  @media (min-width: 768px) {
    .myd-header {
      padding: var(--myd-header-spacing-mobile-top) var(--myd-header-spacing-tablet-left);
    }

    .header__trailing-element {
      padding-left: 0;
    }
  }
`;

export {
  Header_styles_default
};
